import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Gift = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 16 16"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.055 5a6.27 6.27 0 00.804-.674c.522-.522.871-1.164.983-1.808.123-.706-.057-1.362-.494-1.798-.348-.348-.82-.533-1.365-.533-.775 0-1.593.372-2.242 1.021-1.039 1.039-1.644 2.472-1.97 3.496-.241-1.028-.722-2.416-1.657-3.351C5.613.852 4.972.594 4.366.594c-.495 0-.965.172-1.317.523-.781.781-.675 2.153.236 3.064.325.325.705.595 1.105.819H.999v4h1v7h12V9h1V5h-2.945zm-1.519-2.997c.433-.433.974-.692 1.446-.692.167 0 .402.035.57.203.407.407.178 1.349-.489 2.016-.687.687-1.61 1.159-2.413 1.47h-.792c.29-.899.813-2.132 1.678-2.997zm-6.881.511c-.011-.143-.001-.41.191-.601a.727.727 0 01.521-.194c.332 0 .679.157.952.429.529.529.965 1.371 1.26 2.436l.023.086-.086-.023c-1.064-.295-1.906-.731-2.436-1.26a1.42 1.42 0 01-.426-.872zM7 15H3V8.5h4V15zm0-7H2V6h5v2zm6 7H9V8.5h4V15zm1-7H9V6h5v2z"
  }));
});
Gift.displayName = 'Gift';
export var GiftDimensions = {
  height: 16,
  width: 16
};